"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optional = exports.inject = exports.injectable = exports.Container = exports.rootContainer = void 0;
__exportStar(require("./react-ioc"), exports);
var container_context_1 = require("./container-context");
Object.defineProperty(exports, "rootContainer", { enumerable: true, get: function () { return container_context_1.rootContainer; } });
var inversify_1 = require("inversify");
Object.defineProperty(exports, "Container", { enumerable: true, get: function () { return inversify_1.Container; } });
Object.defineProperty(exports, "injectable", { enumerable: true, get: function () { return inversify_1.injectable; } });
Object.defineProperty(exports, "inject", { enumerable: true, get: function () { return inversify_1.inject; } });
Object.defineProperty(exports, "optional", { enumerable: true, get: function () { return inversify_1.optional; } });
//# sourceMappingURL=index.js.map